export const addPrefixToStringMapValues = <
  T extends Record<string, string>,
  P extends string,
>(
  obj: T,
  prefix: P,
): { [K in keyof T]: `${P}${T[K]}` } => {
  const entries = Object.entries(obj).map(
    ([key, value]): [keyof T, `${P}${T[keyof T]}`] => [
      key as keyof T,
      `${prefix}${value}` as `${P}${T[keyof T]}`,
    ],
  );

  return Object.fromEntries(entries) as { [K in keyof T]: `${P}${T[K]}` };
};
